import { render, staticRenderFns } from "./ReservationTypeInput.vue?vue&type=template&id=4771a0e2&scoped=true&"
import script from "./ReservationTypeInput.vue?vue&type=script&lang=js&"
export * from "./ReservationTypeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771a0e2",
  null
  
)

export default component.exports